import React, { Component } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import deleteGif from '../../../src/assets/assets_theme/img/trash-can.gif'
import Select from 'react-select';
import API from "../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PopupImage from "../Bar/PopupImage";
import PreviewQuestionModal from "../Bar/PreviewQuestionModal";

const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    [{ color: [] }, { background: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image', 'video'],
    ['clean'],
  ],
};

class QuestionEdit extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openModal: false,
      question_id: null,
      all_categories: [],
      all_answers: [
        {
          text: "",
          sound_url: "",
          sound_name: "",
          image_url: "",
          full_image_url: "",
          full_sound_url: "",
          ref: null,
        },
        {
          text: "",
          sound_url: "",
          sound_name: "",
          image_url: "",
          full_image_url: "",
          full_sound_url: "",
          ref: null,
        },
        {
          text: "",
          sound_url: "",
          sound_name: "",
          image_url: "",
          full_image_url: "",
          full_sound_url: "",
          ref: null,
        },
        {
          text: "",
          sound_url: "",
          sound_name: "",
          image_url: "",
          full_image_url: "",
          full_sound_url: "",
          ref: null,
        },

      ],

      questions: {
        category_id: 0,
        // enable_bold: false,
        // enable_box: false,
        sound_ref: null,
        type: 1,
        image_type: 1,
        level: null,
        code: null,
        name: null,
        question: null,
        // image_url: [],
        image_url: null,
        full_image_url: null,
        sound_url: null,
        full_sound_url: null,
        sound_name: null,
        upload_progress: 0,
        filename: null,
        preview_thumbnail_progress: null,
        preview_video_progress: 0,
        video_url: null,
        full_video_url: ''
      },
      // topic : [
      //   {question_topic: ''},
      //   {enable_bold: false},
      //   {enable_box: false},
      // ],
      topic: {
        question_topic: '',
        enable_bold: 0,
        enable_box: 0,
      },
      question: [
        { quiz: '' },
        { enable_bold: false },
        { enable_box: false },
      ],
      four_images: [
        {
          image_url: "",
          full_image_url: "",
          upload_progress: 0
        },
        {
          image_url: "",
          full_image_url: "",
          upload_progress: 0
        },
        {
          image_url: "",
          full_image_url: "",
          upload_progress: 0
        },
        {
          image_url: "",
          full_image_url: "",
          upload_progress: 0
        }
      ],

      answer: {
        correct_answer: 0,
        sound_url: null,
        sound_name: null,
        upload_progress: 0,
        filename: null,
        summary: null
      },
      isVisible: false,
      fourimageVisible: false,
      image_type: 1,
      listion_or_reading: 21,
      fields: {
        code: "",
        category_id: "",
        level: "",
        correct_answer: ""
      },
      errors: {},




      data: null,
      count: 1,
      video_id: null,
      episode_id: 0,
      // video_id : this.getParam("id"), 
      // video: {
      //   id: null,
      //   title_kh : "",
      //   title_en : "",
      //   title_ch : "",
      //   description_kh: "",
      //   description_en: "",
      //   description_ch: "",
      //   release_date: "",
      //   total_price: 0,
      //   discount: null,
      //   thumbnail_url : "",
      //   preview_video_url: "",
      //   rating: "",
      //   total_rating: "",
      //   options: [],
      //   is_public: 0,
      //   preview_thumbnail_progress: 0,
      //   preview_video_progress: 0
      // },
      all_tags: [],
      selected_tag: [],
      isMulti: false,
      all_eposides: [],
      image_url: null,

      disable: true,
      // edit: false,
      // publish: true,
      // limit_publish: 1,

      success: null,
      error: null,
      tags: [],
    }
    this.inputRefs = {
      level: React.createRef(),
      code: React.createRef(),
      category_id: React.createRef(),
      correct_answer: React.createRef(),
    };
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.handleModal();
      event.preventDefault()
      if (this.state.openModal) {
        document.getElementById("submit").click();
      } else {
        document.getElementById("dismissmodal").click();
        this.handleSubmit(event);
      }
    }
  };

  handleModal = () => {
    this.state.openModal = !this.state.openModal;
    this.setState({});
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  UNSAFE_componentWillMount() {

    if (this.getParam("id")) {
      this.getOneQuestion();
      // this.setState({edit: true})
    } else {
      setTimeout(() => {
        this.setState({})
      }, 300);
    }
    this.getAllCategories();
    this.getImageLink();
    if (this.getParam('success')) {
      toast.success("Your action is successful", {
        data: {
          title: "Success toast",
          text: "This is a success message",
        },
      })
    }
  };

  getImageLink() {
    let url = API.getImage();
    this.state.image_url = url
    this.setState({})
  }

  validateFields = () => {
    const { fields } = this.state;
    const errors = {};
    let firstEmptyField = null;

    // Check for empty fields
    Object.keys(fields).forEach((field) => {
      const value = fields[field];
      if (typeof value !== "string" || !value.trim() || value == 0) {
        errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;

        // Record the first empty field for focus
        if (!firstEmptyField) {
          firstEmptyField = field;
        }
      }
    });

    this.setState({ errors });

    // Focus on the first empty field
    if (firstEmptyField) {
      this.inputRefs[firstEmptyField].current.focus();
    }

    // Return true if no errors
    return Object.keys(errors).length === 0;
  };

  getParam(name) {
    let id = window.location.search.split(`${name}=`)[1]
    this.state.question_id = id
    // this.setState({category_id : id})
    this.setState({})
    return id;
  }

  getAllCategories = async () => {
    try {
      let query = ''
      let results = await API.getAllCategory(query);
      let data = results.data;

      this.setState({ all_categories: data.category });

      // let tags = data.category.map(tag => {
      //   return {
      //     value: tag,
      //     label: tag.name_en,
      //     id: tag.id
      //   }
      // });

      // this.setState({ all_tags : tags });

    } catch (error) {
      console.log(error)
    }
  }

  addRefValue = (data) => {
    this.state.fields.code = data.code;
    if (data.correct_answer) {
      this.state.fields.correct_answer = data.correct_answer.toString()
    }
    if (data.level) {
      this.state.fields.level = data.level.toString()
    }
    if (data.category_id) {
      this.state.fields.category_id = data.category_id.toString()
    }
    this.setState({});
  }

  getOneQuestion = async () => {
    try {
      let query = `id=${this.state.question_id}`
      let results = await API.getOneQuestion(query);


      let data = results.data;
      this.addRefValue(data.quiz);

      // let tag = data.tag.map(t => {
      //   return {
      //     value: t,
      //     label: t.name_en,
      //     id: t.id
      //   }
      // });

      // this.setState({ video : data.video, selected_tag: this.state.isMulti? tag : tag[0], all_eposides: data.episode });
      // if(data.video.is_public) {
      //   this.state.publish = false
      //   this.setState({})
      // }

      // 

      // this.state.questions = data.quiz;

      let quiz = data.quiz;

      this.setState({})

      if (data.quiz.image_url) {

        // this.state.fourimageVisible = data.quiz.image_url.length == 1;

        data.quiz.image_url.forEach((image_url, index) => {
          this.state.four_images[index].image_url = image_url;
        })
      }

      if (data.quiz.full_image_url) {
        data.quiz.full_image_url.forEach((full_image_url, index) => {
          this.state.four_images[index].full_image_url = full_image_url;
        })
      }

      let topic_parse = data.quiz.topic;
      try {
        topic_parse = JSON.parse(topic_parse)
      } catch (error) {

      }
      quiz.four_images = this.state.four_images;

      // let images_type = data.quiz.image_url.length;

      this.state.questions = data.quiz;
      this.createAudio();
      this.createVideo();
      this.state.all_answers = data.quiz.answer;
      this.state.answer = data.quiz;
      this.state.question_id = data.quiz.id;
      this.state.topic = topic_parse;
      // this.setState({ all_answers : data.quiz.answer, answer: data.quiz, question_id: data.quiz.id, topic: topic_parse});
      // this.state.image_type = data.quiz.image_url.length;
      this.setState({});
      // this.setState({});


    } catch (error) {
      console.log(error)
    }
  }

  onQuestionImageChange = async (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file)
      return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      let results = await API.adminUpload(
        formData,
        (percentage) => {
          this.state.questions.upload_progress = percentage;
          this.setState({})

          // this.setState({percentage: percentage})
        }
      );

      if (results) {
        this.state.questions.full_image_url = results.full_url;
        this.state.questions.image_url = results.filename;
        this.state.questions.filename = results.filename
        this.setState({})
      }

    } catch (error) {
      toast.error("Oops! Something went wrong. Please try again.", {
        data: {
          title: "Success toast",
          text: "This is a success message",
        },
      })
      console.log(error)
    }
  }

  // upload episode video
  onChangeFile = (event, answer) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file)
      return
    const formData = new FormData();
    formData.append("file", file);
    answer.image_url = URL.createObjectURL(file);
    this.setState({})

    try {
      API.adminUpload(
        formData,
        (percentage) => {
          answer.upload_progress = percentage;
          this.setState({})
        }
      ).then(result => {
        answer.upload_progress = 100;
        answer.full_image_url = result.full_url;
        answer.image_url = result.filename;

        this.setState({})
      }).catch(error => {
        toast.error("Oops! Something went wrong. Please try again.", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        console.log(error)
      })
    } catch (error) {
      console.log(error)
    }
  }
  onQuestionFourImageChange = async (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    try {
      let results = await API.adminUpload(
        formData,
        (percentage) => {
          this.state.questions.preview_thumbnail_progress = percentage;
          this.setState({})
        }
      );
      if (results) {
        this.state.questions.preview_thumbnail_progress = 100;
        this.state.questions.image_url = results.filename;
        this.state.questions.full_image_url = results.full_url;
        this.setState({});
        // this.setState({ image_url: results.filename })
      }

    } catch (error) {
      toast.error("Oops! Something went wrong. Please try again.", {
        data: {
          title: "Success toast",
          text: "This is a success message",
        },
      })
      console.log(error)
    }
  }

  // onQuestionFourImageChange = (event, image) => {
  //   event.preventDefault();
  //   let file = event.target.files[0];
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   image.image_url =  URL.createObjectURL(file);
  //   this.setState({})

  //   try {
  //     API.adminUpload(
  //       formData,
  //       (percentage) => {
  //         image.upload_progress = percentage;
  //         this.setState({})
  //       }
  //     ).then(result => {
  //       console.log(result)
  //       image.upload_progress = 100;
  //       image.full_image_url = result.full_url;
  //       image.image_url = result.filename;

  //       this.setState({})

  //     }).catch( error => {

  //       console.log(error)
  //     }) 
  //   } catch (error) {
  //     toast.error("Oops! Something went wrong. Please try again.", {
  //       data: {
  //         title: "Error toast",
  //         text: "This is a error message",
  //       },
  //     })
  //     console.log(error)
  //   }

  // }

  removeAudioQuestion() {
    if (!this.state.questions.full_sound_url) return;
    var audioElement = document.getElementById("question_audio");
    if (audioElement) {
      audioElement.remove();
    }
  }

  createAudio() {
    if (!this.state.questions.full_sound_url) return;
    var audioElement = document.getElementById("question_audio");
    if (audioElement) {
      audioElement.remove();
    }
    var audio = document.createElement('audio');

    // Set the source of the audio file
    audio.src = this.state.questions.full_sound_url;
    audio.id = "question_audio"
    audio.setAttribute('style', 'width: 100%')
    // Add controls (optional)
    audio.controls = true;

    // Append the audio element to the body
    document.getElementById('audio_src').appendChild(audio);
  }

  removeVideoQuestion() {
    if (!this.state.questions.full_video_url) return;
    var audioElement = document.getElementById("question_video");
    if (audioElement) {
      audioElement.remove();
    }
  }

  createVideo() {
    if (!this.state.questions.full_video_url) return;
    var videoElement = document.getElementById("question_video");
    if (videoElement) {
      videoElement.remove();
    }
    var video = document.createElement('video');

    // Set the source of the audio file
    video.src = this.state.questions.full_video_url;
    video.id = "question_video"
    video.setAttribute('style', 'width: 100%')
    video.setAttribute('style', 'height: 460px')
    // video.setAttribute('style', 'textAlign: center') 
    // video.setAttribute('style', 'display: flex') 
    // video.setAttribute('style', 'justifyContent: center') 
    // video.setAttribute('style', 'alignItems: center') 
    // Add controls (optional)
    video.controls = true;

    // Append the audio element to the body
    document.getElementById('video_src').appendChild(video);
  }

  onPreviewVideo = async (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file)
      return;
    const formData = new FormData();
    formData.append("file", file);


    try {
      let results = await API.adminUpload(
        formData,
        (percentage) => {
          this.state.questions.preview_video_progress = percentage;
          this.setState({})

          // this.setState({percentage: percentage})
        }
      );
      if (results) {
        this.state.questions.preview_video_progress = 100;
        this.state.questions.video_url = results.filename;
        this.state.questions.full_video_url = results.full_url;
        this.setState({})
        this.createVideo();

      }

    } catch (error) {
      console.log(error)
    }
  }

  onSoundQuestionChange = (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file)
      return;
    this.state.questions.sound_name = file.name;
    const formData = new FormData();
    formData.append("file", file);
    this.state.questions.full_sound_url = URL.createObjectURL(file);
    this.createAudio();
    if (this.state.questions.sound_ref) {
      this.state.questions.sound_ref.pause();
      this.state.questions.sound_ref.load();
    }

    this.setState({})

    try {
      API.adminUpload(
        formData,
        (percentage) => {
          this.state.questions.upload_progress = percentage;
          this.setState({})
        }
      ).then(result => {
        this.state.questions.upload_progress = 100;
        this.state.questions.sound_url = result.filename;
        this.state.questions.full_sound_url = result.full_url;

        this.setState({})
      }).catch(error => {
        console.log(error)
      })
    } catch (error) {
      console.log(error)
    }
  }

  onSoundCorrectAnswerChange = (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file)
      return;
    this.state.answer.sound_name = file.name;
    const formData = new FormData();
    formData.append("file", file);
    this.state.answer.sound_url = URL.createObjectURL(file);
    this.setState({})

    try {
      API.adminUpload(
        formData,
        (percentage) => {
          this.state.answer.upload_progress = percentage;
          this.setState({})
        }
      ).then(result => {
        this.state.answer.upload_progress = 100;
        this.state.answer.sound_url = result.filename;

        this.setState({})
      }).catch(error => {
        console.log(error)
      })
    } catch (error) {
      console.log(error)
    }
  }

  onSoundAnswerChange = (event, answer) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file)
      return;
    answer.sound_name = file.name;
    const formData = new FormData();
    formData.append("file", file);
    answer.full_sound_url = URL.createObjectURL(file);

    if (answer.ref) {
      answer.ref.pause();
      answer.ref.load();
    }

    this.setState({})

    try {
      API.adminUpload(
        formData,
        (percentage) => {
          answer.upload_progress = percentage;
          this.setState({})
        }
      ).then(result => {
        answer.upload_progress = 100;
        answer.sound_url = result.filename;
        answer.full_sound_url = result.full_url;

        this.setState({})
      }).catch(error => {
        console.log(error)
      })
    } catch (error) {
      console.log(error)
    }
  }

  handelInput = (event) => {

    const { name, value } = event.target;
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: "", // Clear error for the field being updated
      },
    }));
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.validateFields()) return;

    // let image_url = [];

    // for (let i = 0; i < this.state.image_type; i++) {
    //   let image = this.state.four_images[i];

    //   if (image.image_url && image.image_url != "") {

    //     image_url.push(image.image_url);
    //   }
    // }


    let data = {
      id: this.state.question_id,
      code: this.state.questions.code,
      topic: JSON.stringify({ question_topic: this.state.topic.question_topic, enable_bold: 0, enable_box: 0 }),
      score: this.state.questions.score,
      name: this.state.questions.name,
      category_id: this.state.questions.category_id,
      question: this.state.questions.question,
      // image_url: this.state.questions.filename,
      sound_url: this.state.questions.sound_url,
      image_url: this.state.questions.image_url ? this.state.questions.image_url : null,

      answer: JSON.stringify(
        this.state.all_answers.map(answer => {
          return {
            text: answer.text,
            sound_url: answer.sound_url,
            image_url: answer.image_url,
            sound_name: answer.sound_name,
          }
        })
      ),
      correct_answer: this.state.answer.correct_answer,
      level: this.state.questions.level,
      sound_name: this.state.questions.sound_name,
      video_url: this.state.questions.video_url,
      summary: this.state.answer.summary,



      // thumbnail_url: this.state.video.filename ? this.state.video.filename : this.state.video.thumbnail_url,


      //   videos_category_id: JSON.stringify(this.state.isMulti? this.state.selected_tag.map(tag => {
      //     return {
      //       category_id: tag.id,
      //       video_id: this.state.video_id
      //     }
      //   }) : 
      //   [{
      //       category_id: this.state.selected_tag.id,
      //       video_id: this.state.video_id
      //   }]
      // ),
    };

    // if (data.image_url == '[]') {
    //   delete data.image_url;
    // }


    try {
      let results = await API.postQuestion(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        this.state.success = true;
        this.goBack();

        // this.setState({ success: true })
        this.setState({})
      }

    } catch (error) {
      console.log(error)
    }
  }

  handleQuestionChange = (value) => {
    this.state.questions.question = value;
    this.setState({});
    // this.setState({ questions.question: value });
  };

  questionInformationView() {
    // const { questions.preview_video_url } = this.state;
    const { fields, errors } = this.state;
    let category_type = "";

    if (this.state.questions.category_id < 21 && this.state.questions.category_id != 0) {
      category_type = "READING";
    } else if (this.state.questions.category_id > 21) {
      category_type = "LISTENNING";
    }

    return <form className="card" onSubmit={(e) => this.handleSubmit(e)}>
      <h4 className="card-title"><strong>Create question</strong></h4>
      <div className="card-body row">
        <div className="col-md-6">
          <h5>Question</h5>
          <div className="form-group">
            {/* <label ><h6>Question Code</h6> </label> */}
            <label className="require" for="input-required">Question Code </label>
            <input type="text" className="form-control" id="input-required" name="code" required

              value={this.state.questions.code}
              ref={this.inputRefs.code}
              style={{
                border: errors.code ? "1px solid red" : "", // Apply red border on error
              }}
              onChange={(event) => {
                this.state.questions.code = event.target.value;
                this.setState({})
                this.handelInput(event)
              }} />
            {errors.code && <span style={{ color: "red" }}>{errors.code}</span>}
            {/* <select id="inputState" className="form-control" value={this.state.questions.type} disabled
                  onChange={(event) => {
                    this.state.questions.type = event.target.value;
                    this.state.isVisible = !this.state.isVisible;
                    this.setState({})
                  }}
                  >
                  <option value={1}>Reading</option>
                  <option value={2}>Listenning</option> 
              </select> */}
          </div>
          <div className="form-group">
            <label className="require" for="input-required">Category: <b className="text-success fw-500 w-80px">{category_type} </b></label>
            <select id="inputState" className="form-control" value={this.state.questions.category_id}
              ref={this.inputRefs.category_id} name="category_id"
              style={{
                border: errors.category_id ? "1px solid red" : "", // Apply red border on error
              }}
              onChange={(event) => {
                this.state.questions.category_id = event.target.value;
                this.state.questions.category_id < this.state.listion_or_reading ? this.state.questions.type = 1 : this.state.questions.type = 2;
                this.setState({})
                this.handelInput(event)
              }}>
              <option value={0}>Please select category</option>
              {
                this.state.all_categories.map((category, index) => {
                  return <option value={category.id}>{index + 1 + `.`} {category.name}</option>
                })}
            </select>
            {errors.category_id && <span style={{ color: "red" }}>{errors.category_id}</span>}
          </div>
          <div className="form-group">
            <label className="require" for="input-required">Level </label>
            <select id="inputState" className="form-control" value={this.state.questions.level} name="level"
              ref={this.inputRefs.level}
              style={{
                border: errors.level ? "1px solid red" : "", // Apply red border on error
              }}
              onChange={(event) => {
                this.state.questions.level = event.target.value;
                this.setState({})
                this.handelInput(event)
              }}>
              <option value={0}>Please select level</option>
              <option value={1}>Level 1</option>
              <option value={2}>Level 2</option>
              <option value={3}>Level 3</option>
            </select>
            {errors.level && <span style={{ color: "red" }}>{errors.level}</span>}
          </div>
          <div className="form-group">
            <label>Question Topic </label>
            {/* <span>&nbsp;</span><span>&nbsp;</span> <input type="checkbox" checked={this.state.topic[1].enable_bold} 
            onChange={(event) => {
              this.state.topic[1].enable_bold = !this.state.topic[1].enable_bold;
              this.setState({})
            }} /> <b>Bold</b>
            
            <span>&nbsp;</span><span>&nbsp;</span> <input type="checkbox" checked={this.state.topic[2].enable_box} 
            onChange={(event) => {
              this.state.topic[2].enable_box = !this.state.topic[2].enable_box;
              this.setState({})
            }} /> <b style={{border: '1px solid gray'}}>Box</b> */}
            <input type="text" className="form-control" id="input-required" name="title_kh" required

              value={this.state.topic.question_topic}
              onChange={(event) => {
                this.state.topic.question_topic = event.target.value;
                this.setState({})
              }} />
          </div>
          <div className="form-group">
            <label >Name</label>
            <textarea type="text" className="form-control" id="input-required" name="description_kh" required
              value={this.state.questions.name}
              style={{ height: '100px' }}
              onChange={(event) => {
                this.state.questions.name = event.target.value;
                this.setState({})
              }} />
          </div>
          <div className="form-group">
            <label >Question</label>
            {/* <span>&nbsp;</span><span>&nbsp;</span> <input type="checkbox" checked={this.state.question[1].enable_bold} 
            onChange={(event) => {
              this.state.question[1].enable_bold = !this.state.question[1].enable_bold;
              this.setState({})
            }} /> <b>Bold</b>
            
            <span>&nbsp;</span><span>&nbsp;</span> <input type="checkbox" checked={this.state.question[2].enable_box} 
            onChange={(event) => {
              this.state.question[2].enable_box = !this.state.question[2].enable_box;
              this.setState({})
            }} /> <b style={{border: '1px solid gray'}}>Box</b>
            <textarea type="text" className="form-control" id="input-required" name="title_kh"  required
            
            value={this.state.question[0].quiz} 
            onChange={(event) => {
              this.state.question[0].quiz = event.target.value;
              this.setState({})
            }}/> */}


            {/* <ReactQuill 
              theme="snow" 
              modules={modules}
              style={{"height" : "300px"}} 
              value={this.state.questions.question} 
              onChange={this.handleQuestionChange} /> */}
            {/* <br /><br /><br /> */}
            <textarea type="text" className="form-control" id="input-required" name="description_kh" required
              value={this.state.questions.question}
              style={{ height: '100px' }}
              onChange={(event) => {
                this.state.questions.question = event.target.value;
                this.setState({})
              }} />

            {/* <div style={{ textAlign: 'center'}}>
                {
                  this.state.questions.full_image_url && <PopupImage
                  thumbnailUrl={this.state.questions.full_image_url} // Thumbnail image
                  imageUrl={this.state.questions.full_image_url} // Full-size popup image
                />
                }
              </div><br /> 

              <input type="file" data-provide="dropify" onChange={this.onQuestionImageChange} />
                <div class="progress">
                </div>
                <br />  
                
                <input type="file" id="des" hidden className="form-control" 
                  onChange={(e) => this.onSoundQuestionChange(e)}
                />  
              <button onClick={(e) => {
                e.preventDefault()
                document.getElementById("des").click()
              }} type="buttom" className="form-control btn-primary" ><span style={{color: 'black'}}>{this.state.questions.sound_name? this.state.questions.sound_name : 'Upload Sound'}</span>
              </button> 

              {
                this.state.questions.full_sound_url && <audio ref={(ref) => this.state.questions.sound_ref = ref} controls style={{width: '100%'}}> 
                  <source src={this.state.questions.full_sound_url} type="audio/mpeg"></source>
                </audio>
               } */}
          </div>
          <div className="form-group">
            {/* <br /> */}
            <label >Image</label> &emsp;
            {/* btn-square */}
            {/* <button  type="buttom" className="btn btn-danger" onClick={(e) => {
                  e.preventDefault()
                  this.state.questions.full_image_url = null;
                  this.state.questions.image_url = null;
                  this.state.questions.preview_thumbnail_progress= 0;

                  this.setState({});
                  }}><i class="fa fa-trash"></i>Image</button> */}
            {/* <div style={{ textAlign: 'center'}}> */}
            <div style={{
              marginTop: '10px',
              textAlign: 'center',
              // MaxHeight: '50px',
              height: this.state.questions.full_image_url ? '250px' : 0,
              // objectFit: 'cover'
              display: 'flex', // Flexbox for alignment
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              {
                this.state.questions.full_image_url && <PopupImage
                  thumbnailUrl={this.state.questions.full_image_url}
                  imageUrl={this.state.questions.full_image_url}
                />
              }
            </div>
            <input type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onQuestionFourImageChange(e)} />
            <div class="progress">
              <div class="progress-bar" role="progressbar" style={{ width: this.state.questions.preview_thumbnail_progress + "%", height: "10px" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{this.state.questions.preview_thumbnail_progress ? this.state.questions.preview_thumbnail_progress + "%" : null}</strong></div>
            </div>
          </div>
          {/* sound */}
          <div className="row">
            <div className="col-md-6">
              <label >Sound</label> &emsp;
              {/* <button  type="buttom" className="btn btn-danger" 
                        onClick={(e) => {

                          e.preventDefault()
                          this.removeAudioQuestion();
                          this.state.questions.full_sound_url = '';
                          this.state.questions.sound_url = '';
                          this.state.questions.sound_name = null;
                          
                          this.setState({});
                          }}><i class="fa fa-trash"></i>Sound</button> */}


              <input type="file" id="des" hidden className="form-control" accept="audio/mp3"
                onChange={(e) => this.onSoundQuestionChange(e)}
              />
              <button onClick={(e) => {
                e.preventDefault()
                document.getElementById("des").click()
              }} type="buttom" className={`form-control ${this.state.questions.sound_name ? 'btn-primary' : 'btn-info'}`} ><span style={{ color: 'black' }}>{this.state.questions.sound_name ? this.state.questions.sound_name : 'Upload Sound'}</span>
              </button>
              <div id="audio_src">

              </div>

            </div>
            <div className="col-md-6" style={{ paddingTop: '8px' }}>
              <br />
              <div className="row">
                <button type="buttom" className="btn btn-danger"
                  onClick={(e) => {

                    e.preventDefault()
                    this.removeAudioQuestion();
                    this.state.questions.full_sound_url = '';
                    this.state.questions.sound_url = '';
                    this.state.questions.sound_name = null;

                    this.setState({});
                  }}><i class="fa fa-trash"></i>Sound</button> &emsp;
                <button type="buttom" className="btn btn-danger" onClick={(e) => {
                  e.preventDefault()
                  this.state.questions.full_image_url = null;
                  this.state.questions.image_url = null;
                  this.state.questions.preview_thumbnail_progress = 0;

                  this.setState({});
                }}><i class="fa fa-trash"></i>Image</button>&emsp;
                <button type="buttom" className="btn btn-danger"
                  onClick={(e) => {

                    e.preventDefault()
                    this.removeVideoQuestion();
                    this.state.questions.full_video_url = '';
                    this.state.questions.video_url = '';
                    this.state.questions.preview_video_progress = 0;
                    // this.state.questions.v = null;

                    this.setState({});
                  }}><i class="fa fa-trash"></i>Video</button>
              </div>
            </div>
          </div>
          <div className="form-group">
            <label style={{ paddingTop: '10px', paddingBottom: '18.5px' }}>Video Details </label>
            {/* &emsp;<button  type="buttom" className="btn btn-danger" 
                onClick={(e) => {

                  e.preventDefault()
                  this.removeVideoQuestion();
                  this.state.questions.full_video_url = '';
                  this.state.questions.video_url = '';
                  this.state.questions.preview_video_progress= 0;
                  // this.state.questions.v = null;
                  
                  this.setState({});
                  }}><i class="fa fa-trash"></i>Video</button> */}
            <div id="video_src" style={{
              display: 'flex', // Flexbox for centering
              justifyContent: 'center', // Align horizontally
              alignItems: 'center', // Align vertically
              width: '100%', // Set a fixed width for the container
              height: this.state.questions.full_video_url ? '460px' : '0', // Set a fixed height for the container
              // border: '1px solid #ddd',
              borderRadius: '5px',
              overflow: 'hidden', // Prevent overflow
              margin: '0 auto', // Center the container itself horizontally
              // backgroundColor: '#f9f9f9',
            }}>

            </div>
            <div style={{ paddingTop: '3px' }}></div>
            <input
              accept="video/mp4"
              onChange={(e) => this.onPreviewVideo(e)}
              type="file" data-provide="dropify" />
            <div class="progress">
              <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                style={{ width: this.state.questions.preview_video_progress + "%", height: "10px" }}
              >
                <strong>{this.state.questions.preview_video_progress ? this.state.questions.preview_video_progress + "%" : null}</strong>
              </div>
            </div>
            {/* <input type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onQuestionFourImageChange(e)} /> 
              <div class="progress">
                  <div class="progress-bar" role="progressbar" style={{width:  "10%", height: '10px'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{ "20%"}</strong></div>
                </div>  */}
          </div>
        </div>




        <div className="col-md-6">
          <h5 style={{ paddingLeft: '15px' }}>Answers</h5>
          <div className="col-md-12">
            {
              this.state.all_answers.map((answer, index) => {
                return <div className="row">
                  <div className="form-group col-md-7">
                    <label className="require" for="input-required">Answer {index + 1} </label> &emsp;
                    {/* btn-square  */}


                    <div className={this.state.isVisible ? '' : ''}>
                      <textarea type="text" className="form-control" id="input-required" name="description_kh" required style={{ height: '140px' }}
                        value={answer.text}
                        onChange={(event) => {
                          answer.text = event.target.value;
                          this.setState({})
                        }} />
                      <br />


                      <input type="file" id={`sound${index + 1}`} hidden className="form-control" accept="audio/mp3"
                        onChange={(e) => this.onSoundAnswerChange(e, answer)}
                      />
                    </div>

                    <div className={this.state.isVisible ? '' : ''}>
                      <div className="row">
                        <div className="col-md-5">
                          <button onClick={(e) => {
                            e.preventDefault()
                            document.getElementById(`sound${index + 1}`).click()
                          }} type="buttom" className={`form-control ${answer.sound_url ? 'btn-primary' : 'btn-info'}`} ><span style={{ color: 'black', width: '120px' }}>{answer.sound_name ? answer.sound_name : 'Upload Sound'}</span>
                          </button>
                        </div>

                        <div className="col-md-7">
                          <div className="row">
                            <button type="buttom" className="btn btn-danger" onClick={(e) => {
                              e.preventDefault()
                              answer.full_sound_url = null;
                              answer.sound_url = null;
                              answer.sound_name = null;
                              this.setState({});
                            }}><i class="fa fa-trash"></i> Sound</button>&nbsp;
                            <button type="buttom" className="btn btn-danger" onClick={(e) => {
                              e.preventDefault()
                              answer.full_image_url = null;
                              answer.image_url = null;
                              answer.sound_name = null;
                              this.setState({});
                            }}><i class="fa fa-trash"></i> Image</button>
                          </div>
                        </div>
                      </div>

                      {
                        answer.full_sound_url && <audio ref={(ref) => answer.ref = ref} controls style={{ width: '100%' }}>
                          <source src={answer.full_sound_url} type="audio/mpeg"></source>
                        </audio>
                      }
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div style={{
                      marginTop: answer.full_image_url ? '35px' : 0,
                      textAlign: 'center',
                      // MaxHeight: '50px',
                      height: answer.full_image_url ? '250px' : 0,
                      // objectFit: 'cover'
                      display: 'flex', // Flexbox for alignment
                      justifyContent: 'center', // Align horizontally
                      alignItems: 'center', // Align vertically
                    }}>
                      {
                        answer.full_image_url && <PopupImage style={{ paddingTop: '0px' }}
                          thumbnailUrl={answer.full_image_url}
                          imageUrl={answer.full_image_url}
                        />
                      }
                    </div>

                    <div style={{ marginTop: '6px' }}>
                      <br />
                      {!answer.full_image_url && <div><input id={`dropid${index + 1}`} type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onChangeFile(e, answer)} /></div>}
                      {/* <input  id={`dropid${index+1}`} type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onChangeFile(e, answer)} /> */}
                    </div>
                    <br />
                  </div>


                  <br />
                </div>
              })
            }
            <div className="">
              <div className="form-group">
                <label className="require" for="input-required">Correct Answer </label>
                <select id="inputState" className="form-control" value={this.state.answer.correct_answer} name="correct_answer"
                  ref={this.inputRefs.correct_answer}
                  style={{
                    border: errors.correct_answer ? "1px solid red" : "", // Apply red border on error
                  }}
                  onChange={(event) => {
                    this.state.answer.correct_answer = event.target.value;
                    this.setState({})
                    this.handelInput(event)
                  }}
                >
                  <option value={0}>Please choose the correct answer</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                </select>
                {errors.correct_answer && <span style={{ color: "red" }}>{errors.correct_answer}</span>}
              </div>
            </div>
            <br />
            {/* <div className="row">
              <div className="col-md-6">
                  <div className="text-left">
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text-right">
                      <Link to="/questionindex" className="btn btn-secondary" >Back</Link>
                      <button className="btn btn-secondary" onClick={this.goBack}>Back</button>
                      <button className="btn btn-primary" data-toggle="modal" data-target="#modal-question" id="submit">Submit</button>
                      <button className="btn btn-success">Publish</button>
                  </div>
                </div>
              </div>  */}
          </div>
        </div>
        {/* <div className="col-md-6">
        <div className="form-group">
            <label className="require" for="input-required">Question code </label>
            <input type="text" className="form-control" id="input-required" name="title_kh"  required
            
            value={this.state.question_code} 
            onChange={(event) => {
              this.state.questions.question_code = event.target.value;
              this.setState({})
            }}/>
          </div> */}
        {/* <div className="form-group"> */}


        {/* <label className="require" for="input-required">Thumbnail</label>
            <img 
              className={this.state.video.thumbnail_url? "h-300px w-fullscreen" : ""} 
              src={this.state.video.thumbnail_url} 
                /> 
              
            <input type="file" data-provide="dropify" name='thumbnail_url' onChange={e => this.onThumbnailChange(e)}  />
              <div class="progress">
                <div class="progress-bar" role="progressbar" style={{width: this.state.video.preview_thumbnail_progress + "%", height: '10px'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                  <strong>{this.state.video.preview_thumbnail_progress + "%"}</strong>
                </div>
                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" 
                style={{width: this.state.video.preview_thumbnail_progress + "%"}}></div>
              </div> */}
        {/* </div> */}
        {/* </div>  */}

      </div>
      <div className="card-body row">


        {/* <div className="col-md-12">            
      <div className={this.state.fourimageVisible ? 'row' : 'row '}>

      {
          this.state.four_images && this.state.four_images.map((image, index) => {
            if (index < this.state.image_type) {
              return  <div className="col-md-6">
              <div className="form-group">
                <label className="" for="input-required">Image</label> &emsp;
                <button  type="buttom" className="btn btn-danger" onClick={(e) => {
                  e.preventDefault()
                  this.state.questions.full_image_url = null;
                  this.state.questions.image_url = null;
                  this.state.questions.preview_thumbnail_progress= 0;

                  this.setState({});
                  }}><i class="fa fa-trash"></i>Image</button>
                <div style={{
                    marginTop: '10px',
                    textAlign: 'center', 
                    MaxHeight: '50px',
                    height: this.state.questions.full_image_url ? '250px' : 0,
                    objectFit: 'cover',
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    }}>
                {
                  this.state.questions.full_image_url && <PopupImage
                  thumbnailUrl={this.state.questions.full_image_url} 
                  imageUrl={this.state.questions.full_image_url} 
                />
                }
              </div><br /> 


              
                <input type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onQuestionFourImageChange(e, image)} /> 
                <div class="progress">
                  <div class="progress-bar" role="progressbar" style={{width: this.state.questions.preview_thumbnail_progress + "%", height: "10px"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{this.state.questions.preview_thumbnail_progress ? this.state.questions.preview_thumbnail_progress + "%" : null}</strong></div>
                </div>   

                
              </div>

              
            </div> 
            } 
            
            return <div/>
          })
      }

      

        </div> 
      </div> */}



      </div>
      {/* <footer className="card-footer text-right">
            <div className="card-body row">
            <div className="col-md-6">
                <div className="text-left">
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-right">
                    <button className="btn btn-secondary" onClick={this.goBack}>Back</button>
                    <button className="btn btn-primary" data-toggle="modal" data-target="#modal-question" id="submit">Submit</button>
                </div>
              </div>
            </div> 
        </footer> */}

    </form>

  }

  goBack = () => {
    this.props.navigate(-1); // Navigate to the previous page
  };

  scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth', // Optional: for smooth scrolling
    });
  };

  render() {
    return (
      <div className="col-12">
        <ToastContainer />
        <div className="float_plus_button">
          {/* <Link to="#" className="btn btn-float btn-primary" onClick={this.onAddChild}>  <i className="ion-plus-round"></i></Link> */}
        </div>
        {/* <div className="float_top">
            <Link to="#" className="btn btn-float btn-info" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>  <i className="fa fa-level-up"></i></Link>
            <Link to="#" className="btn btn-float btn-info" onClick={this.scrollToBottom}>  <i className="fa fa-level-down"></i></Link>
          </div> */}
        {/* {this.state.success && (
              <Navigate to="/questionindex?success=true" replace={true} />
          )} */}

        {this.questionInformationView()}

        <footer className="card-footer text-right">
          <div className="card-body row">
            <div className="col-md-6">
              <div className="text-left">
              </div>
            </div>
            <div className="col-md-6">
              <div className="text-right">
                <button className="btn btn-secondary" onClick={this.goBack}>Back</button>
                <button className="btn btn-primary" data-toggle="modal" data-target="#modal-question" id="submit">Submit</button>
              </div>
            </div>
          </div>
        </footer>

        {/* <div className="card">
            <h4 className="card-title">Answers</h4>
            <div className="card-body row">
                  

                {
              this.state.all_answers.map((answer, index) => {
                return <div className="col-md-6">
                <div className="form-group">
                    <label className="require" for="input-required">Answer {index + 1} </label> &emsp;
                    <button  type="buttom" className="btn btn-danger" onClick={(e) => {
                      e.preventDefault()
                      answer.full_image_url = null;
                      answer.image_url = null;
                      answer.sound_name = null;
                      this.setState({});
                      }}><i class="fa fa-trash"></i> Image</button> &nbsp;

                    <button  type="buttom" className="btn btn-danger" onClick={(e) => {
                      e.preventDefault()
                      answer.full_sound_url = null;
                      answer.sound_url = null;
                      answer.sound_name= null;
                      this.setState({});
                      }}><i class="fa fa-trash"></i> Sound</button>
                      
                    <div className={this.state.isVisible ? '' : ''}>   
                        <textarea type="text" className="form-control" id="input-required" name="description_kh" required
                        value={answer.text}
                        onChange={(event) => {
                          answer.text = event.target.value;
                          this.setState({})
                        }}/>
                        <br />
                        <div style={{
                            marginTop: '10px',
                            textAlign: 'center', 
                            height: answer.full_image_url ? '250px' : 0,
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            }}>
                        {
                          answer.full_image_url && <PopupImage
                          thumbnailUrl={answer.full_image_url} 
                          imageUrl={answer.full_image_url} 
                        />
                        }
                        </div><br />

                        <input id={`dropid${index+1}`} type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onChangeFile(e, answer)} />
                          <br /> 
                        
                        <input type="file" id={`sound${index+1}`} hidden className="form-control" accept="audio/mp3"
                          onChange={(e) => this.onSoundAnswerChange(e, answer)}
                        />   
                      </div>  

                    <div className={this.state.isVisible ? '' : ''}>
                      <button onClick={(e) => {
                        e.preventDefault()
                        document.getElementById(`sound${index+1}`).click()
                      }} type="buttom" className="form-control btn-primary" ><span style={{color: 'black'}}>{answer.sound_name ? answer.sound_name : 'Upload Sound'}</span>
                      </button>  
                      
                      { 
                        answer.full_sound_url && <audio ref={(ref) => answer.ref = ref} controls style={{width: '100%'}}> 
                          <source src={answer.full_sound_url} type="audio/mpeg"></source>
                        </audio>
                      }
                    </div>

                </div>
                <br />
              </div>
              })
            }
            
            
            
            </div>
          </div> */}


        {
          <PreviewQuestionModal
            questions={this.state.questions}
            question_images={this.state.four_images}
            answer={this.state.answer}
            all_answers={this.state.all_answers}
            image_type={this.state.image_type}
            topic={this.state.topic}
            onSubmit={this.handleSubmit}
            handleModal={this.handleModal}
          />
        }
      </div>
    );
  }
}

const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <QuestionEdit navigate={navigate} />;
};

export default MyComponentWithNavigate;
